
export default {
  v3SubmitErrBtnViewOrder: '查看订单',
  v3SubmitErrBtnBackHome: '返回首页',
  v3SubmitErrBtnRetry: '重试',
  v3SubmitErrBtnRelogin: '重新登录',
  v3SubmitErrBtnSwitchPay: '切换支付方式',
  v3SubmitErrBtnReorder: '重新下单',
  v3SubmitErrBtnSwitchServer: '切换区服',
  v3SubmitErrBtnViewOrderStatus: '查看订单状态',
  v3SubmitErrBtnBackStore: '返回商城',
  v3SubmitErrBtnGoUpdate: '去更新',
  v3SubmitErrBtnResubscribe: '重新订阅',
  v3SubmitErrTipUpdateApp: '请前往应用商店更新',
  v3SubmitErrTipRelogin: '请重新登录',

  v3SubmitErrMsg120009: '订单已处理，请前往游戏内查看背包。',
  v3SubmitErrMsg120003: '商品信息有误，请重新选择商品。',
  v3SubmitErrMsg120016: '提交过于频繁，请稍等几秒再试。',
  v3SubmitErrMsg120025: '请求参数异常，请重新登录后重试。',
  v3SubmitErrMsg121012: '支付渠道暂时不可用，请尝试其他方式。',
  v3SubmitErrMsg120012: '网络不稳定，请检查网络连接后重试。',
  v3SubmitErrMsg120002: '未检测到游戏角色，请先创建角色。',
  v3SubmitErrMsg121019: '订单信息错误，请重新下单。',
  v3SubmitErrMsg120024: '预注册礼包已领取，无需重复操作。',
  v3SubmitErrMsg120000: '登录已过期，请重新登录。',
  v3SubmitErrMsg120014: '订单号无效，请重新下单。',
  v3SubmitErrMsg121001: '充值到游戏失败，请稍后重试或联系客服。',
  v3SubmitErrMsg120015: '支付金额异常，请重新选择商品。',
  v3SubmitErrMsg120001: '游戏区服不匹配，请切换至正确区服。',
  v3SubmitErrMsg120020: '支付渠道返回异常，请尝试其他方式。',
  v3SubmitErrMsg120010: '游戏充值功能暂时关闭，请稍后再试。',
  v3SubmitErrMsg120006: '金额验证失败，请重新选择。',
  v3SubmitErrMsg121010: '沙盒环境充值请求无效，请使用正式版。',
  v3SubmitErrMsg120017: '订单号重复，请检查是否已支付。',
  v3SubmitErrMsg120022: '支付回调验证失败，请稍后重试。',
  v3SubmitErrMsg121000: '系统繁忙，请稍后重试。',
  v3SubmitErrMsg120011: '商品ID错误，请重新选择。',
  v3SubmitErrMsg121015: '支付金额校验失败，请重新下单。',
  v3SubmitErrMsg120004: '当前支付渠道未开放，请选择其他方式。',
  v3SubmitErrMsg120005: '支付渠道维护中，请使用其他方式。',
  v3SubmitErrMsg120007: '平台ID有误，请重新登录。',
  v3SubmitErrMsg120008: '请求参数不足，请重新提交。',
  v3SubmitErrMsg120013: '开发商订单号错误，请重新下单。',
  v3SubmitErrMsg120018: '支付被风控拦截，请联系客服核实。',
  v3SubmitErrMsg120019: '包名验证失败，请使用官方版本。',
  v3SubmitErrMsg120021: '商品ID验证失败，请重新选择。',
  v3SubmitErrMsg120023: '预注册礼包发奖异常，请稍后查看。',
  v3SubmitErrMsg120026: '账号不存在，请检查账号状态。',
  v3SubmitErrMsg120030: '商品总库存不足，请选择其他商品。',
  v3SubmitErrMsg120031: '您已超出该商品限购数量，请调整。',
  v3SubmitErrMsg120032: '游戏版本过旧，请下载最新版本。',
  v3SubmitErrMsg120080: '风控代理支付限制，请使用自有支付方式。',
  v3SubmitErrMsg120081: '风控代理支付延迟，请稍后查看结果。',
  v3SubmitErrMsg121002: '订单缓存失效，请重新下单。',
  v3SubmitErrMsg121003: '充值配置不存在，请联系客服。',
  v3SubmitErrMsg121004: '扩展参数不足，请重新提交。',
  v3SubmitErrMsg121005: '缓存写入失败，请稍后重试。',
  v3SubmitErrMsg121006: '缓存读取失败，请稍后重试。',
  v3SubmitErrMsg121007: '充值类型配置错误，请联系客服。',
  v3SubmitErrMsg121011: '苹果渠道检测到新字段，请更新应用。',
  v3SubmitErrMsg121013: '续订订单不存在，请重新订阅。',
  v3SubmitErrMsg121014: '储值参数解密失败，请重新提交。',
  v3SubmitErrMsg121017: '此订单已退款，请联系客服确认。',
  v3SubmitErrMsg121018: '订阅已过期，请重新订阅。',
  v3SubmitErrMsg121020: '订单已取消，请重新下单。',
  v3SubmitErrMsg121021: 'Google API 异常，请稍后重试。',
  v3SubmitErrMsg121022: '获取访问令牌失败，请重新登录。',
  v3SubmitErrMsg121023: '订单状态异常，请查询到账状态。',
  v3SubmitErrMsg121024: '订单确认失败，请稍后重试。'
};
